const initialState = { supplierId: null, settings: {} };
const cateringReducer = (state = initialState, action) => {
	switch (action.type) {
		case "SET_CATERING":
			return { ...action.state, supplierId: +action.state.supplierId }; //! ID MUST be casted to int
		case "UPDATE_CATERING_SETTINGS":
			return { ...state, settings: action.state };
		default:
			return state;
	}
};

export default cateringReducer;
